import React from 'react';
import styles from './MobileMessage.module.css';

const MobileMessage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img 
          src="/logo.svg" 
          alt="Pralok Logo" 
          className={styles.logo}
        />
        <h1 className={styles.title}>Pralok Assistant</h1>
        <p className={styles.subtitle}>Discuss • Learn • Solve</p>
        
        <div className={styles.messageBox}>
          <h2 className={styles.messageTitle}>Desktop Only</h2>
          <p className={styles.messageText}>
            Pralok is currently optimized for desktop and laptop computers. 
            Features like camera access, speech-to-text, and screen capture 
            require desktop capabilities.
          </p>
          <p className={styles.suggestion}>
            Please visit Pralok on your computer for the full experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileMessage; 